import api from 'api';

export const getFunctions = (params) => {
  return api.get('/functions', params, 'bearer');
};
